import React from 'react';
import { iconStyle } from './styles';

export const Emergency: React.FC<{ size?: string }> = ({ size }) => {
  return (
    <div style={iconStyle(size)}>
      <svg
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Parent-View---Family-Profile"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="2-Family-Profile---Parent-Goals"
            transform="translate(-137.000000, -1160.000000)"
          >
            <g
              id="Goal---Education-Fund"
              transform="translate(17.000000, 665.000000)"
            >
              <g
                id="Progress-+-icon"
                transform="translate(115.000000, 83.000000)"
              >
                <circle
                  id="Oval-5-Copy"
                  fill="#500F71"
                  cx="55"
                  cy="462.000017"
                  r="50"
                ></circle>
                <g
                  id="icon-/-emergency-/-white-copy"
                  transform="translate(27.000000, 435.000000)"
                  stroke="#FFFFFF"
                >
                  <path
                    d="M14.0909091,41.6666667 L42.9090909,41.6666667 C44.0136604,41.6666667 44.9090909,42.5620972 44.9090909,43.6666667 L44.9090909,48.3333333 L12.0909091,48.3333333 L12.0909091,43.6666667 C12.0909091,42.5620972 12.9863396,41.6666667 14.0909091,41.6666667 Z"
                    id="Rectangle-Copy-9"
                  ></path>
                  <path
                    d="M9.63636364,48.3333333 L47.3636364,48.3333333 C47.9159211,48.3333333 48.3636364,48.7810486 48.3636364,49.3333333 L48.3636364,52.6119174 C48.3636364,53.1642021 47.9159211,53.6119174 47.3636364,53.6119174 L9.63636364,53.6119174 C9.08407889,53.6119174 8.63636364,53.1642021 8.63636364,52.6119174 L8.63636364,49.3333333 C8.63636364,48.7810486 9.08407889,48.3333333 9.63636364,48.3333333 Z"
                    id="Rectangle-Copy-10"
                  ></path>
                  <path
                    d="M27.7738008,25.5026778 C24.3277766,25.5026778 20.194063,28.9204795 20.194063,32.7148438 C20.1887435,33.1134572 20.3861124,33.4842305 20.7105916,33.6851844 C21.0350709,33.8861383 22.0752119,33.8861383 22.3996912,33.6851844 C22.7241704,33.4842305 22.9215393,33.1134572 22.9162198,32.7148438 C22.9162198,30.3689675 25.4489899,28.1079378 27.7738008,28.1079378 C28.1494675,28.1135822 28.4988967,27.9041575 28.6882824,27.5598582 C28.8776682,27.2155588 28.8776682,26.3950567 28.6882824,26.0507574 C28.4988967,25.706458 28.1494675,25.4970334 27.7738008,25.5026778 Z"
                    id="Path-Copy-20"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M28.5,21.6666667 C35.6545979,21.6666667 41.4545455,27.4666142 41.4545455,34.6212121 L41.4545455,41.6666667 L15.5454545,41.6666667 L15.5454545,34.6212121 C15.5454545,27.4666142 21.3454021,21.6666667 28.5,21.6666667 Z"
                    id="Rectangle-Copy-11"
                  ></path>
                  <path
                    d="M28.3717552,0.00799588139 C27.4820791,0.0832127191 26.8145129,0.668886279 26.8337624,1.35731796 L26.8337624,11.9858242 C26.8249438,12.4649574 27.1521408,12.9106268 27.6900609,13.1521734 C28.227981,13.39372 28.8932821,13.39372 29.4312022,13.1521734 C29.9691223,12.9106268 30.2963193,12.4649574 30.2875007,11.9858242 L30.2875007,1.35731796 C30.2982137,0.974696854 30.0939609,0.607102782 29.7270513,0.348676387 C29.3601417,0.0902499913 28.8662113,-0.0339092117 28.3717552,0.00799588139 Z"
                    id="Path-Copy-18"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M45.4058521,8.86168441 L38.5341483,15.492874 C38.0835405,15.9064033 37.8996546,16.5226187 38.0533471,17.1040757 C38.2070395,17.6855327 38.6743194,18.1414677 39.2751309,18.2961965 C39.8759425,18.4509253 40.516501,18.2802953 40.9499817,17.8500547 L47.8216855,11.2188651 C48.3684418,10.7233254 48.5188674,9.94277888 48.1932811,9.2906852 C47.8676948,8.63859152 47.1413632,8.26569697 46.3990281,8.3695258 C46.0204242,8.42230862 45.6709025,8.59551066 45.4058521,8.86168441 Z"
                    id="Path-Copy-16"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M46.2197488,24.9101337 C45.7290658,24.937899 45.2878863,25.2809557 45.0624371,25.8100475 C44.8369878,26.3391393 44.8615295,26.9738622 45.1268153,27.4750665 C45.3921011,27.9762708 45.8578167,28.2677905 46.3484904,28.2397872 L57.3344453,28.2397872 C57.8296924,28.248289 58.2903501,27.9328474 58.5400202,27.4142535 C58.7896902,26.8956596 58.7896902,26.2542613 58.5400202,25.7356674 C58.2903501,25.2170736 57.8296924,24.9016319 57.3344453,24.9101337 L46.3484904,24.9101337 C46.3056001,24.9076939 46.2626391,24.9076939 46.2197488,24.9101337 Z"
                    id="Path-Copy-17"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M10.1896296,8.34113141 C9.52025839,8.403993 8.95027702,8.83759088 8.73068114,9.4509869 C8.51108525,10.0643829 8.68217216,10.7450148 9.16860243,11.1931612 L16.0471012,17.8306123 C16.4810106,18.2612591 17.1222025,18.4320503 17.7236082,18.2771754 C18.3250138,18.1223005 18.7927558,17.665935 18.9466002,17.0839289 C19.1004446,16.5019229 18.9163769,15.8851256 18.4653235,15.4712059 L11.5868247,8.83375473 C11.2225822,8.47362826 10.7086746,8.29243461 10.1896296,8.34113141 Z"
                    id="Path-Copy-19"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M-0.416614866,24.8416527 C-0.90729784,24.869418 -1.34847734,25.2124747 -1.57392657,25.7415665 C-1.7993758,26.2706583 -1.77483412,26.9053812 -1.50954831,27.4065855 C-1.24426249,27.9077898 -0.778546981,28.1993094 -0.287873207,28.1713061 L10.6980817,28.1713061 C11.1933287,28.179808 11.6539865,27.8643663 11.9036566,27.3457724 C12.1533266,26.8271786 12.1533266,26.1857802 11.9036566,25.6671864 C11.6539865,25.1485925 11.1933287,24.8331509 10.6980817,24.8416527 L-0.287873207,24.8416527 C-0.330763499,24.8392129 -0.373724574,24.8392129 -0.416614866,24.8416527 Z"
                    id="Path-Copy-21"
                    fillRule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
